import { ILookupItem } from './types';

export const metabaseDashboards: ILookupItem[] = [
  {
    id: 52,
    label: 'Welcome to Powernet Hub Dashboard'
  },
  {
    id: 4,
    label: 'Supervisors Overview'
  },
  {
    id: 17,
    label: 'SLT Overview'
  },
  {
    id: 28,
    label: 'All Text Fields'
  },
  {
    id: 26,
    label: 'Supervisor Workflow Analysis and Trends'
  },
  {
    id: 58,
    label: 'Vehicle Pre Start'
  },
  {
    id: 53,
    label: 'Complete Forms with PDF'
  },
  {
    id: 162,
    label: 'HSE Inspections'
  }
];
